/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';
// @ts-ignore
import { Pageable } from '../model/pageable';
// @ts-ignore
import { PagedModelTipoPraticaIstitutoDTO } from '../model/paged-model-tipo-pratica-istituto-dto';
// @ts-ignore
import { TipoPraticaIstitutoCreationForm } from '../model/tipo-pratica-istituto-creation-form';
// @ts-ignore
import { TipoPraticaIstitutoDTO } from '../model/tipo-pratica-istituto-dto';
// @ts-ignore
import { TipoPraticaIstitutoListFilter } from '../model/tipo-pratica-istituto-list-filter';
// @ts-ignore
import { TipoPraticaIstitutoPatchForm } from '../model/tipo-pratica-istituto-patch-form';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    TipoPraticaIstitutoControllerServiceInterface,
    CreateTipoPraticaIstitutoRequestParams,
    DeleteTipoPraticaIstitutoRequestParams,
    GetTipoPraticaIstitutoRequestParams,
    ListTipoPraticaIstitutiRequestParams,
    UpdateTipoPraticaIstitutoRequestParams
} from './tipo-pratica-istituto-controller.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class TipoPraticaIstitutoControllerService extends BaseService implements TipoPraticaIstitutoControllerServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Crea un nuovo Istituto per il TipoPratica
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/istituti
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public createTipoPraticaIstituto(requestParameters: CreateTipoPraticaIstitutoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TipoPraticaIstitutoDTO>;
    public createTipoPraticaIstituto(requestParameters: CreateTipoPraticaIstitutoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TipoPraticaIstitutoDTO>>;
    public createTipoPraticaIstituto(requestParameters: CreateTipoPraticaIstitutoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TipoPraticaIstitutoDTO>>;
    public createTipoPraticaIstituto(requestParameters: CreateTipoPraticaIstitutoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling createTipoPraticaIstituto.');
        }
        const tipoPraticaIstitutoCreationForm = requestParameters?.tipoPraticaIstitutoCreationForm;
        if (tipoPraticaIstitutoCreationForm === null || tipoPraticaIstitutoCreationForm === undefined) {
            throw new Error('Required parameter tipoPraticaIstitutoCreationForm was null or undefined when calling createTipoPraticaIstituto.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/istituti`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TipoPraticaIstitutoDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: tipoPraticaIstitutoCreationForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Elimina un Istituto (cascade su Plessi e Assegnazioni)
     * @endpoint delete /api/v1/gestione/tipi-pratica/{idTipoPratica}/istituti/{idIstituto}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public deleteTipoPraticaIstituto(requestParameters: DeleteTipoPraticaIstitutoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public deleteTipoPraticaIstituto(requestParameters: DeleteTipoPraticaIstitutoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public deleteTipoPraticaIstituto(requestParameters: DeleteTipoPraticaIstitutoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public deleteTipoPraticaIstituto(requestParameters: DeleteTipoPraticaIstitutoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling deleteTipoPraticaIstituto.');
        }
        const idIstituto = requestParameters?.idIstituto;
        if (idIstituto === null || idIstituto === undefined) {
            throw new Error('Required parameter idIstituto was null or undefined when calling deleteTipoPraticaIstituto.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/istituti/${this.configuration.encodeParam({name: "idIstituto", value: idIstituto, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Dettaglio di un Istituto per id
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/istituti/{idIstituto}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getTipoPraticaIstituto(requestParameters: GetTipoPraticaIstitutoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TipoPraticaIstitutoDTO>;
    public getTipoPraticaIstituto(requestParameters: GetTipoPraticaIstitutoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TipoPraticaIstitutoDTO>>;
    public getTipoPraticaIstituto(requestParameters: GetTipoPraticaIstitutoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TipoPraticaIstitutoDTO>>;
    public getTipoPraticaIstituto(requestParameters: GetTipoPraticaIstitutoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling getTipoPraticaIstituto.');
        }
        const idIstituto = requestParameters?.idIstituto;
        if (idIstituto === null || idIstituto === undefined) {
            throw new Error('Required parameter idIstituto was null or undefined when calling getTipoPraticaIstituto.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/istituti/${this.configuration.encodeParam({name: "idIstituto", value: idIstituto, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TipoPraticaIstitutoDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lista paginata degli Istituti del TipoPratica (filtri: nome, codice_meccanografico, attivo, q)
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/istituti
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listTipoPraticaIstituti(requestParameters: ListTipoPraticaIstitutiRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PagedModelTipoPraticaIstitutoDTO>;
    public listTipoPraticaIstituti(requestParameters: ListTipoPraticaIstitutiRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PagedModelTipoPraticaIstitutoDTO>>;
    public listTipoPraticaIstituti(requestParameters: ListTipoPraticaIstitutiRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PagedModelTipoPraticaIstitutoDTO>>;
    public listTipoPraticaIstituti(requestParameters: ListTipoPraticaIstitutiRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling listTipoPraticaIstituti.');
        }
        const filter = requestParameters?.filter;
        if (filter === null || filter === undefined) {
            throw new Error('Required parameter filter was null or undefined when calling listTipoPraticaIstituti.');
        }
        const pageable = requestParameters?.pageable;
        if (pageable === null || pageable === undefined) {
            throw new Error('Required parameter pageable was null or undefined when calling listTipoPraticaIstituti.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'filter',
            <any>filter,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'pageable',
            <any>pageable,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/istituti`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PagedModelTipoPraticaIstitutoDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Replace di un Istituto (richiede version per optimistic lock)
     * @endpoint put /api/v1/gestione/tipi-pratica/{idTipoPratica}/istituti/{idIstituto}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public updateTipoPraticaIstituto(requestParameters: UpdateTipoPraticaIstitutoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TipoPraticaIstitutoDTO>;
    public updateTipoPraticaIstituto(requestParameters: UpdateTipoPraticaIstitutoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TipoPraticaIstitutoDTO>>;
    public updateTipoPraticaIstituto(requestParameters: UpdateTipoPraticaIstitutoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TipoPraticaIstitutoDTO>>;
    public updateTipoPraticaIstituto(requestParameters: UpdateTipoPraticaIstitutoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling updateTipoPraticaIstituto.');
        }
        const idIstituto = requestParameters?.idIstituto;
        if (idIstituto === null || idIstituto === undefined) {
            throw new Error('Required parameter idIstituto was null or undefined when calling updateTipoPraticaIstituto.');
        }
        const tipoPraticaIstitutoPatchForm = requestParameters?.tipoPraticaIstitutoPatchForm;
        if (tipoPraticaIstitutoPatchForm === null || tipoPraticaIstitutoPatchForm === undefined) {
            throw new Error('Required parameter tipoPraticaIstitutoPatchForm was null or undefined when calling updateTipoPraticaIstituto.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/istituti/${this.configuration.encodeParam({name: "idIstituto", value: idIstituto, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TipoPraticaIstitutoDTO>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: tipoPraticaIstitutoPatchForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
